<template>
  <div class='newplace full_layout'>
    <img src="/static/images/activty/tradingrules/tradingrules_01.png">
    <img src="/static/images/activty/tradingrules/tradingrules_02.png">
    <img src="/static/images/activty/tradingrules/tradingrules_03.png">
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.tradingRules'));
  },
  methods: {
    
  },
}

</script>
<style scoped>
.newplace img{
  width: 100%;
  display: block;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/tradingrules.vue